export default {
  status                    : {
    initializing              : false,
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  borrower: null,
  borrowerSearch: null,
  borrowers: [],
  borrowersIsUnApproved: [],
  borrowerOptions: [],
  borrowerContractOptions: [],
  surety: null,
  suretySearch: null,
  sureties: [],
  suretyOptions: [],
  suretyContractOptions: []
}
